import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ViewStudentsPanel = ({ classroom, students, onClose, onViewStudent, onAddStudent }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return 'text-success bg-success/10';
      case 'inactive': return 'text-muted-foreground bg-muted';
      case 'suspended': return 'text-warning bg-warning/10';
      default: return 'text-muted-foreground bg-muted';
    }
  };

  return (
    <div className="fixed inset-0 z-[1001] flex">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50"
        onClick={onClose}
      />
      {/* Panel */}
      <div className="relative ml-auto w-full max-w-lg h-full bg-card shadow-2xl flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between px-4 py-3 border-b border-border bg-card">
          <button
            onClick={onClose}
            className="flex items-center gap-2 px-3 py-2 bg-primary/10 hover:bg-primary/20 text-primary rounded-lg transition-colors font-semibold text-sm flex-shrink-0"
          >
            <Icon name="ArrowLeft" size={18} />
            <span>Back</span>
          </button>
          <div className="flex-1 min-w-0 mx-3 text-center">
            <h2 className="text-base font-semibold text-foreground truncate">{classroom?.classroomName}</h2>
            <p className="text-xs text-muted-foreground">
              {students?.length} student{students?.length !== 1 ? 's' : ''}
              {classroom?.gradeLevel ? ` · ${classroom?.gradeLevel}` : ''}
            </p>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-muted rounded-lg transition-colors flex-shrink-0"
          >
            <Icon name="X" size={20} className="text-muted-foreground" />
          </button>
        </div>

        {/* Add Student Button */}
        <div className="px-6 py-3 border-b border-border">
          <Button
            iconName="UserPlus"
            onClick={onAddStudent}
            className="w-full"
          >
            Add Student
          </Button>
        </div>

        {/* Student List */}
        <div className="flex-1 overflow-y-auto">
          {students?.length === 0 ? (
            <div className="flex flex-col items-center justify-center h-full py-16 px-6 text-center">
              <div className="w-16 h-16 bg-muted rounded-full flex items-center justify-center mb-4">
                <Icon name="Users" size={28} className="text-muted-foreground" />
              </div>
              <h3 className="text-base font-semibold text-foreground mb-1">No Students Yet</h3>
              <p className="text-sm text-muted-foreground">Add students to this classroom to get started.</p>
            </div>
          ) : (
            <ul className="divide-y divide-border">
              {students?.map((student) => (
                <li key={student?.id} className="flex items-center justify-between px-6 py-4 hover:bg-muted/40 transition-colors">
                  <div className="flex items-center space-x-3 min-w-0">
                    <div className="w-9 h-9 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
                      <span className="text-sm font-semibold text-primary">
                        {student?.firstName?.charAt(0)}{student?.lastName?.charAt(0)}
                      </span>
                    </div>
                    <div className="min-w-0">
                      <p className="text-sm font-medium text-foreground truncate">{student?.fullName}</p>
                      <p className="text-xs text-muted-foreground font-mono">{student?.username}</p>
                    </div>
                  </div>
                  <div className="flex items-center space-x-2 flex-shrink-0 ml-3">
                    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${getStatusColor(student?.status)}`}>
                      {student?.status?.charAt(0)?.toUpperCase() + student?.status?.slice(1)}
                    </span>
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => onViewStudent?.(student?.id)}
                    >
                      View
                    </Button>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewStudentsPanel;
